export const SUBMIT_TO_ERP_MODAL_TITLE =
  'Are you sure you want to send this order to Acumatica?';
export const SUBMIT_TO_ERP_MODAL_SUBTITLE =
  'Under normal circumstances, this will be done automatically.';
export const SUBMIT_TO_ERP_SUBMIT_BUTTON_TEXT = 'Yes, send to Acumatica';
export const SUBMIT_TO_ERP_CANCEL_BUTTON_TEXT = 'No, Cancel';
